<template>
  <!-- <v-layout>
      <h1>Fixed Cost #{{$route.params.id}}</h1>
  </v-layout>-->
  <v-col class="pa-0">
    <v-flex my-2>
      <SimpleCard>
        <v-row xs12 column pt-3>
          <router-link class="driverNavigation" to="/invoices">
            <h4>Invoices</h4>
          </router-link>
          <router-link class="driverNavigation" to="/taxis">
            <h4>Taxis</h4>
          </router-link>
          <router-link class="driverNavigation" to="/drivers/create">
            <h4>Register Driver</h4>
          </router-link>
          <router-link class="driverNavigation" to="/drivers/applications">
            <h4>Driver Applications</h4>
          </router-link>
          <v-flex shrink ml-4>
            <v-divider vertical></v-divider>
          </v-flex>
          <v-flex pl-3>
            <v-row justify="start" v-if="driverStats">
              <Stat name="Total Drivers" :value="driverStats.total" />
              <Stat name="Active" :value="driverStats.active" />
              <Stat name="Locked Out" :value="driverStats.lockedOut" />
              <!-- <Stat name="Action Required" :value="driverStats.actionRequired" /> -->
              <Stat
                name="Awaiting Activation"
                :value="driverStats.awaitingActivation"
              />
              <Stat name="Applying" :value="driverStats.applying" />
            </v-row>
          </v-flex>
        </v-row>
      </SimpleCard>
    </v-flex>
    <v-layout>
      <v-flex xs6 md5 lg4 xl4 pb-2>
        <SimpleCard>
          <v-col justify-center>
            <v-flex>
              <DriverSearchBox
                @search="search"
                @clear="clear"
                :query="query"
                :show-all-button="true"
              ></DriverSearchBox>
            </v-flex>
            <v-flex pl-1 pt-0>
              <v-layout row wrap align-content-center justify-center>
                <v-flex v-if="loading" xs12 pa-1 class="text-xs-center">
                  <v-progress-circular
                    :size="48"
                    :width="5"
                    color="primary"
                    indeterminate
                  ></v-progress-circular>
                </v-flex>
                <DriverList
                  v-if="!loading"
                  style="width: 100%"
                  :drivers="drivers"
                  :paginationProp="pagination"
                  @driverSelected="getDriver"
                ></DriverList>
                <v-flex v-if="!loading">
                  <v-row justify="end" class="ma-2">
                    <v-btn
                      small
                      :disabled="pagination.page <= 1"
                      @click="changePage(pagination.page - 1)"
                      >
                      <v-icon small>mdi-arrow-left</v-icon>
                    </v-btn
                    >

                    <v-btn
                      class="ml-1"
                      small
                      @click="changePage(pagination.page + 1)"
                      :disabled="noMoreResults == true"
                      >
                      <v-icon small>mdi-arrow-right</v-icon>
                    </v-btn
                    >
                  </v-row>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-col>
        </SimpleCard>
      </v-flex>
      <v-flex pl-3 xs6 md7 lg8 xl8 pb-2>
        <SimpleCard v-if="!loadingDriver">
          <v-col justify-center>
            <v-flex>
              <v-layout row wrap align-content-center justify-center>
                <v-flex v-if="loadingDriver" xs12 pa-1 class="text-xs-center">
                  <v-progress-circular
                    :size="48"
                    :width="5"
                    color="primary"
                    indeterminate
                  ></v-progress-circular>
                </v-flex>
                <DriversMapMarkers
                  ref="driversMap"
                  :set-selected-driver="setSelectedDriver"
                  :enable-drag-to-update="true"
                  :drivers="drivers"
                  :show-state-summary="false"
                  style="height: 800px"
                >
                </DriversMapMarkers>
              </v-layout>
            </v-flex>
          </v-col>
        </SimpleCard>
      </v-flex>
    </v-layout>
  </v-col>
</template>

<script>
import Stat from "@/components/widget/Stat.vue";
import SimpleCard from "@/components/widget/SimpleCard.vue";
import DriverList from "@/components/driver/DriverList.vue";
import DriverSearchBox from "@/components/driver/DriverSearchBox.vue";
import DriversMapMarkers from "@/components/driver/DriversMapMarkers.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "DriversMap",
  components: {
    SimpleCard,
    DriverList,
    DriverSearchBox,
    Stat,
    DriversMapMarkers
  },

  data: function () {
    return {
      selectedTaxi: -1,
      driver: null,
      drivers: [],
      bookings: [],
      offset: 0,
      count: 20,
      query: {
        showAll: false,
        search: "",
        rideType: [],
        lockedOut: false,
        plannerFilter: "filter_all",
      },
      loading: true,
      loadingDriver: false,
      pagination: { page: 1 },
      num_pages: 0,
      noMoreResults: false,
      driverStats: null,
    };
  },
  mounted: async function () {
    this.getDrivers();
    this.getSummary();
//    this.setCoordinates()
  },
  methods: {
    setSelectedDriver: function (taxiID) {
      
      if (this.selectedTaxi == taxiID) {
        this.selectedTaxi = -1;
      } else {
        this.selectedTaxi = taxiID;
      }
      
      try {
        // console.log(this);
        this.$refs.driversMap.updateMarkers(this.selectedTaxi);
        this.$refs.driversMap.zoomToTaxi(this.selectedTaxi);
      } catch (e) {
        console.log(e);
      }
    },
  
    search: function () {
      this.pagination.page = 1;
      this.noMoreResults = false;
      this.getDrivers();
    },
    clear: function () {
      this.query = {
        search: "",
        lockedOut: false,
      };
    },
    changePage: function (page) {
      this.pagination.page = page;
      this.getDrivers();
    },
    getDrivers: async function () {
      this.loading = true;

      try {
        let queryRideType =
          this.query.rideType == "" ? -1 : this.query.rideType;
  
        var url = `${this.$store.state.apiUrl}/driver/all?offset=${
          this.count * (this.pagination.page - 1)
        }&count=${this.count}&filter=${this.query.plannerFilter}`;

        if (this.query.rideType.length > 0) {
          for (var i = 0; i < this.query.rideType.length; i++) {
            url += `&rideType=${this.query.rideType[i]}`;
          }
        }

        if (this.query.plannerFilter && this.query.plannerFilter == 'filter_locked_out') {
            this.query.lockedOut = true
        } else {
            this.query.lockedOut = false
        }
        
        url += `&lockedOut=${this.query.lockedOut}`;

        url += `&query=${this.query.search}`;
        url += `&showAll=${this.query.showAll}`;

        let response = await axios.get(url, {
          params: {},
        });

        console.log(response.data);

        if (response.data.error != null) {
          if (response.data.error == "no_results") {
            this.noMoreResults = true;
          } else {
            this.noMoreResults = false;
          }
        }

        var drivers = response.data.drivers;

        if (drivers != null && drivers.length < this.count) {
          this.noMoreResults = true;
        } else if (drivers != null && drivers.length == this.count) {
          this.noMoreResults = false;
        }

        this.drivers = drivers;
        this.$refs.driversMap.updateMarkers(null);

        this.pagination.page = response.data.pages.page;
        this.num_pages = response.data.pages.num_pages;

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log("Failed to get drivers " + error);
      }
    },
    getDriver: async function (id) {
      this.setSelectedDriver(id)
      return false
      this.loadingDriver = true;
      this.driver = null;

      try {
        var url = `${this.$store.state.apiUrl}/driver/${id}/get`;

        let response = await axios.get(url, {
          params: {},
        });

        this.driver = response.data;

        this.loadingDriver = false;
      } catch (error) {
        this.loadingDriver = false;
        console.log("Failed to get driver " + error);
      }
    },
    getSummary: async function (id) {
      try {
        var url = `${this.$store.state.apiUrl}/driver/summary`;

        let response = await axios.get(url, {
          params: {},
        });

        this.driverStats = response.data;
      } catch (error) {
        console.log("Failed to get stats " + error);
      }
    },
    failed: function (data) {
      alert("Request Failed with error: " + data.message);
    },
  },
};
</script>


<style  lang="scss">
.driverNavigation {
  padding-left: 12px;
  padding-right: 12px;
  color: #999fb8 !important;
}
</style>
